export default __webpack_public_path__ + "static/HeaderLogoMenuWithSubsTopMenu-61f8c9d3fe04395725f12bb6a7a09a38.jpg";